import { FC, useEffect } from 'react';
import invariant from 'tiny-invariant';
import { useShallow } from 'zustand/react/shallow';

import { usePaymentEnv } from '../../context/paymentEnvContext';
import { useInternalStore } from '../../stores/useInternalStore';
import { useFetchTrueLayerReports } from '../../utils/useFetchTrueLayerReports';
import { useRedirectToTrueLayer } from '../../utils/useRedirectToTrueLayer';
import { StripePaymentContainer } from '../StripePaymentContainer';

import { AddSepaPaymentMethodFlow } from './AddSepaPaymentMethodFlow';

export interface ISepaPaymentProps {
	onCancel: VoidFunction;
}

export const SepaPayment: FC<ISepaPaymentProps> = ({ onCancel }) => {
	const { trueLayerRedirectUrl } = usePaymentEnv();
	const redirectToTrueLayerHandler = useRedirectToTrueLayer();
	const fetchTrueLayerReports = useFetchTrueLayerReports();

	const { trueLayerAuthCode, accounts, isLoading, trueLayerError } =
		useInternalStore(
			useShallow((s) => ({
				trueLayerAuthCode: s.trueLayerAuthCode,
				accounts: s.accounts,
				isLoading: s.isLoading,
				trueLayerError: s.trueLayerError,
			}))
		);

	useEffect(() => {
		if (trueLayerAuthCode) {
			(async () => {
				invariant(
					trueLayerRedirectUrl,
					'[SepaPayment] trueLayerRedirectUrl is not set'
				);

				await fetchTrueLayerReports({
					authCode: trueLayerAuthCode,
					redirectUrl: trueLayerRedirectUrl,
				});
			})();
		}
	}, [fetchTrueLayerReports, trueLayerAuthCode, trueLayerRedirectUrl]);

	return (
		<StripePaymentContainer>
			<AddSepaPaymentMethodFlow
				accounts={accounts || undefined}
				isLoading={isLoading}
				isError={trueLayerError}
				onRedirectToTrueLayer={redirectToTrueLayerHandler}
				onCancel={onCancel}
			/>
		</StripePaymentContainer>
	);
};
